import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BiPlusCircle } from "react-icons/bi"; 
import JeweleryCard from './JeweleryCard';
import AddItemForm from './AddItemForm';
import { toast } from 'react-toastify';
import Header from './Header';


const Home = ({ jewelry, setJewelry }) => {
  const [showForm, setShowForm] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAdmin, setAdmin] = useState('');
  const [category, setCategory] = useState(''); // State for selected category

  // Fetch items from backend on component mount
  useEffect(() => {
    const fetchItems = async () => {
      const adminStatus = localStorage.getItem('admin');
      setAdmin(adminStatus);
      console.log(adminStatus,"admin");
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}item/items`);
        console.log();
        
        setItems(response.data.data); // Assuming response.data.data contains array of items
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch items:', error);
        setLoading(false);
      }
    };

    fetchItems();
  }, [showForm]);

  const handleAdd = async (item) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}item/items`, item);
      const newItem = response.data.data;
      setJewelry([...jewelry, newItem]);
      setItems([...items, newItem]); // Update items state with new item
      toast.success('Item added successfully');
      setShowForm(false);
      
    } catch (error) {
      console.error('Failed to add item:', error);
      toast.error('Failed to add item');
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await axios.delete(`${process.env.REACT_APP_API_URL}item/items/${id}`);
      setItems(items.filter(item => item._id !== id));
      toast.success('Item deleted successfully');
      setLoading(false);
      
    } catch (error) {
      console.error('Failed to delete item:', error);
      toast.error('Failed to delete item');
    }
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  // Get unique categories from items
  const uniqueCategories = [...new Set(items.map(item => item.category))];

  // Filter items based on the selected category
  const filteredItems = category ? items.filter(item => item.category === category) : items;

  return (
    <div>
      {loading ? (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center  bg-opacity-80 z-50">
      <div className="flex flex-col items-center gap-2">
        <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-green-600"></div>
        <h1 className="text-xl text-green-600 font-medium">Please Wait .......</h1>
      </div>
    </div>
      ) : (
        <div className='pt-[95px]'>
          {!showForm &&  <Header/>}
           <div className="p-4  bg-gray-100">
             
            

             <div className=" flex justify-between items-center mb-4 px-4">
               {/* <h1 className="md:text-2xl text-xl font-bold text-gray-800">Latest Jewellery</h1> */}
               <div className="flex items-center justify-between px-2 w-full">
               {
  !showForm && (
    <div className={` flex items-center w-full {${isAdmin}justify-start:justify-end} `}>
      <select
        value={category}
        onChange={handleCategoryChange}
        className={`block text-lg w-[25%] h-10 pl-3 text-base placeholder-gray-600 border border-gray-300 rounded-lg appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
    
    >
        <option value="">All Categories</option>
        {uniqueCategories.map((cat) => (
          <option key={cat} value={cat}>
            {cat}
          </option>
        ))}
      </select>
    </div>
  )
}

                
                 <div>
                 {!showForm && isAdmin && (
                   <button
                     className="bg-slate-700 text-white p-1 px-2 rounded-full flex items-center justify-center hover:scale-110 hover:bg-cyan-800 transition-colors duration-300"
                     onClick={() => setShowForm(!showForm)}
                   >
                     <BiPlusCircle size={25} />
                     <span className="text-lg ml-1">Add</span>
                   </button>
                 )}
                 </div>
              
               </div>
             </div>
             {showForm && <AddItemForm onAdd={handleAdd} setShowForm={setShowForm} />}
             {!showForm && (
               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                 {filteredItems.map(item => (
                   <JeweleryCard key={item._id} jewelry={item} onDelete={handleDelete} setLoading={setLoading}/>
                 ))}
               </div>
             )}
           </div>
        </div>
       
      )}
    </div>
  );
};

export default Home;
